import type { ComponentType, SVGProps } from "react";
import clsx from "clsx";
import { iconStrokeFix } from "@ui/central-icons/iconUtils";
import IconAudio from "@ui/central-icons/icons/IconAudio";
import IconImages2 from "@ui/central-icons/icons/IconImages2";
import IconText1 from "@ui/central-icons/icons/IconText1";
import IconVideoClip from "@ui/central-icons/icons/IconVideoClip";
import type { FlowPortModality } from "@/app/_api/flowTemplatesServer";

const MODALITY_META: Record<FlowPortModality, { Icon: ComponentType<SVGProps<SVGSVGElement>>; colorClass: string }> = {
  text: { Icon: IconText1, colorClass: "tw-text-gray-500" },
  image: { Icon: IconImages2, colorClass: "tw-text-blue-500" },
  video: { Icon: IconVideoClip, colorClass: "tw-text-purple-500" },
  audio: { Icon: IconAudio, colorClass: "tw-text-pink-500" },
};

export function FlowTemplateModalityIcon({ modality, className }: { modality: FlowPortModality; className?: string }) {
  const { Icon, colorClass } = MODALITY_META[modality];
  return <Icon className={clsx(iconStrokeFix, "tw-shrink-0", colorClass, className)} />;
}
